<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  data: function () {
    return { };
  },
  computed: { },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="inview_animate"
    v-if="isContentVisibleToUser()" 
    list-keypoints-targets-component
    :id="content.name"
  >
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container">
      <div class="row my-4 my-md-5" v-if="content.title">
        <div class="col-12 text-center">
          <h4 class="my-0">{{content.title}}</h4>
        </div>
      </div>
      <div class="row mt-4 mt-md-5 justify-content-center">
        <div class="col-12 col-xl-10 px-sm-0">
          <div class="row">
            <div class="col-12 col-lg-3"  v-for="(keypoint, index) in content.keypoints" :key="`keypoint-${index}`">
              <div class="item py-2 h-100">
                <component
                  :is="!!keypoint.url ? 'a' : 'div'"
                  :href="(keypoint.url || {}).url"
                  :target="getTarget(keypoint.url)" 
                  class="tile-shadow ar-1by1 tile w-100 d-flex justify-content-lg-center align-items-center"
                >
                  <img :src="keypoint.icon.url" v-if="keypoint.icon" class="icon mb-3 mr-3"/>
                  <div class="text-left flex-grow-1">
                    <div class="font-weight-bold title mb-1" v-html="keypoint.title"></div>
                    <div v-html="keypoint.description" class="text-black mb-0 mt-auto"></div>
                  </div>
                </component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keypoints-targets-component] {

  .icon {
    height: 3rem;
    width: auto;
    transition: filter .25s;
  }

  .item {
    height: var(--carousel-height);

    .tile {
      transition: color .25s, shadow .25s;
      border-radius: .5rem;
      padding: 1rem;
      color: black;
      line-height: 1;
      
      .title {
        font-size: 1.25rem;
      }

      p {
        margin-bottom: 0;
        font-size: .875rem;
      }

      @include hover {
        color: $primary;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.32);

        .icon {
          @include recolor-icon;
        }
      }

      @include media-breakpoint-down(md) {
        padding: 15px;
      }

      @include media-breakpoint-up(lg) {
        text-align: center;
      }
    }
  }

}

</style>
